import React, { useState, useEffect } from 'react'
import BaseModal from '../BaseModal'
import { validateEmail } from '../../../utils/regexValidator'
import './EmailsModal.scss'
import Input from '../Input'
import Button from '../Button'
import EmailsList from '../EmailsList'

const EmailsModal = ({ title, titleImage, onClose, onFinish, visible }) => {
  const [email, setEmail] = useState('')
  const [emailsList, setEmailsList] = useState([])

  useEffect(() => {
    setEmail('')
    setEmailsList([])
  }, [visible])

  const addItem = () => {
    if(!emailsList.find(e => e === email) && validateEmail(email)) {
      setEmail('')
      setEmailsList([...emailsList, email])
    }
  }

  const removeItem = email => {
    const filteredList = emailsList.filter(e => e !== email)
    setEmailsList(filteredList)
  }

  return (
    <BaseModal
      title={title}
      titleImage={titleImage}
      onClose={onClose}
      visible={visible}
      size={"medium"}
    >
      <div className='emails-modal-container'>
        {/* <div className='emails-modal-container-head'>
          <p>Estás enviando el manifiesto del</p>
          <span>Miércoles, 20 may. 2020 - 10:34 a.m.</span>
          <div>
            <img src={require('../../../../assets/icons/house.svg')} />
            <p>Lima Plaza Norte</p>
          </div>
        </div> */}
        <div className='emails-modal-container-input'>
          <Input
            key='email'
            placeholder='E-mail'
            value={email}
            onChange={text => setEmail(text)}
            type='add'
            buttonDisabled={!validateEmail(email)}
            onEnter={() => addItem()}
            onClick={() => addItem()}
          />
          <div className='emails-modal-container-input-list'>
            <EmailsList
              emailsList={emailsList}
              removeItem={removeItem}
            />
          </div>
        </div>
        <div className='emails-modal-container-footer'>
          <Button
            text='Cancelar'
            type='secondary'
            onClick={() => onClose()}
          />
          <Button
            text='Mandar correo'
            type='primary'
            onClick={() => onFinish(emailsList)}
            disabled={emailsList.length <= 0}
          />
        </div>
      </div>
    </BaseModal>
  )
}

export default EmailsModal
